/* Saint Luca redesign sections */
(function () {
  'use strict';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* Formats like the store: sample = Liquid "{{ 123456 | money }}" rendered into data-money-sample */
  function money(cents) {
    var el = document.querySelector('[data-money-sample]');
    var smp = el ? el.getAttribute('data-money-sample') : '';
    var m = smp.match(/^(.*?)1(\D?)234(\D)56(.*)$/);
    var v = Math.round(cents);
    if (!m) { return (v / 100).toFixed(2); }
    var whole = Math.floor(v / 100), dec = String(v % 100).padStart(2, '0');
    var w = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, m[2]);
    return m[1] + w + (dec === '00' ? '' : m[3] + dec) + m[4];
  }

  function refreshThemeCart() {
    document.documentElement.dispatchEvent(new CustomEvent('theme:cartchanged', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('sl:cart-updated'));
    if (window.theme && typeof theme.updateCartSummaries === 'function') {
      try { theme.updateCartSummaries(true, true, true); return true; } catch (e) {}
    }
    return false;
  }

  /* Add to cart: ajax, then open the theme cart drawer. Falls back to normal submit. */
  function addToCart(form, btn) {
    var data = new FormData(form);
    if (btn) { btn.disabled = true; btn.dataset.label = btn.dataset.label || btn.innerHTML; btn.innerHTML = btn.dataset.adding || 'Adding…'; }
    return fetch(root + 'cart/add.js', { method: 'POST', body: data, headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' } })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) { alertMsg(form, res.j.description || res.j.message || 'Sorry, this item is unavailable.'); return; }
        if (btn) btn.innerHTML = btn.dataset.added || 'Added';
        if (!refreshThemeCart()) { window.location.href = root + 'cart'; }
      })
      .catch(function () { form.submit(); })
      .finally(function () {
        if (btn) setTimeout(function () { btn.disabled = false; btn.innerHTML = btn.dataset.label; }, 1400);
      });
  }
  function alertMsg(form, msg) {
    var box = form.querySelector('[data-sl-error]');
    if (box) { box.textContent = msg; box.hidden = false; } else { window.alert(msg); }
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-sl-ajax]');
    if (!form) return;
    e.preventDefault();
    addToCart(form, form.querySelector('[type=submit]'));
  });

  /* Sticky add to cart: submits the main product form */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-sl-sticky-add]');
    if (!b) return;
    var form = document.getElementById(b.getAttribute('data-sl-sticky-add'));
    if (form) addToCart(form, b);
  });

  function initSticky(scope) {
    var bar = scope.querySelector('[data-sl-sticky]');
    var atc = scope.querySelector('[data-sl-atc]');
    if (!bar || !atc || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (en) {
      var e = en[0];
      bar.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0);
    }).observe(atc);
  }

  /* Combo viewer: 3 pieces -> 7 combinations */
  function initCombo(scope) {
    scope.querySelectorAll('[data-sl-combo]').forEach(function (box) {
      var pieces = [].slice.call(box.querySelectorAll('[data-sl-piece]'));
      var imgs = [].slice.call(box.querySelectorAll('[data-mask]'));
      var label = box.querySelector('[data-sl-combo-label]');
      var mood = box.querySelector('[data-sl-combo-mood]');
      var hint = box.querySelector('[data-sl-combo-hint]');
      var order = { 1: 1, 2: 2, 4: 3, 3: 4, 5: 5, 6: 6, 7: 7 };
      function update() {
        var mask = 0, count = 0;
        pieces.forEach(function (p, i) { if (p.getAttribute('aria-pressed') === 'true') { mask += (1 << i); count++; } });
        var cur = null;
        imgs.forEach(function (im) { var on = +im.dataset.mask === (mask || 7); im.classList.toggle('is-on', on); if (on) cur = im; });
        var m = cur ? cur.dataset.mood : '';
        if (label) label.textContent = mask ? box.dataset.comboOf.replace('[n]', order[mask]) : box.dataset.comboNone;
        if (mood) mood.textContent = mask ? m : box.dataset.tap;
        if (hint) hint.textContent = mask ? box.dataset.hint.replace('[mood]', m).replace('[count]', count).replace('[pieces]', count === 1 ? box.dataset.piece : box.dataset.pieces) : box.dataset.start;
      }
      pieces.forEach(function (p) {
        p.addEventListener('click', function () { p.setAttribute('aria-pressed', p.getAttribute('aria-pressed') === 'true' ? 'false' : 'true'); update(); });
      });
      update();
    });
  }

  /* Gift tiers: progress from cart total */
  function tierState() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function paintTiers(cart) {
    var rate = parseFloat((window.Shopify && Shopify.currency && Shopify.currency.rate) || 1) || 1;
    document.querySelectorAll('[data-sl-tiers]').forEach(function (box) {
      box.querySelectorAll('[data-sl-amt]').forEach(function (a) { a.textContent = money(Math.ceil(parseFloat(a.dataset.slAmt) * rate) * 100); });
      var tiers = [].slice.call(box.querySelectorAll('[data-threshold]'));
      var total = cart ? cart.total_price : 0;
      var max = 0, next = null;
      tiers.forEach(function (t) {
        var th = Math.ceil(parseFloat(t.dataset.threshold || 0) * rate) * 100;
        t._th = th; if (th > max) max = th;
        var ok = th === 0 ? (cart && cart.item_count > 0) || box.dataset.firstAlways === 'true' : total >= th;
        t.classList.toggle('is-unlocked', !!ok);
        if (!ok && th > 0 && (!next || th < next._th)) next = t;
      });
      var bar = box.querySelector('[data-sl-tiers-bar]');
      if (bar) bar.style.width = (max ? Math.min(100, Math.round(total / max * 100)) : 0) + '%';
      var msg = box.querySelector('[data-sl-tiers-msg]');
      if (msg) {
        if (next) msg.innerHTML = box.dataset.msgNext.replace('[amount]', '<strong>' + money(next._th - total) + '</strong>').replace('[gift]', next.dataset.gift);
        else msg.innerHTML = box.dataset.msgDone;
      }
    });
  }
  function initTiers() {
    if (!document.querySelector('[data-sl-tiers]')) return;
    tierState().then(paintTiers).catch(function () { paintTiers(null); });
  }
  document.addEventListener('sl:cart-updated', function () { setTimeout(initTiers, 400); });
  document.documentElement.addEventListener('theme:cartchanged', function () { setTimeout(initTiers, 400); });

  /* Reels: tap to play native video */
  function initReels(scope) {
    scope.querySelectorAll('[data-sl-reel]').forEach(function (r) {
      var v = r.querySelector('video');
      if (!v) return;
      r.addEventListener('click', function (e) {
        if (e.target.closest('a,button[type=submit],form')) return;
        if (v.paused) {
          scope.querySelectorAll('[data-sl-reel] video').forEach(function (o) { if (o !== v) { o.pause(); o.closest('[data-sl-reel]').classList.remove('is-playing'); } });
          v.muted = false; v.play(); r.classList.add('is-playing');
        } else { v.pause(); r.classList.remove('is-playing'); }
      });
    });
    scope.querySelectorAll('[data-sl-scroll]').forEach(function (b) {
      b.addEventListener('click', function () {
        var s = scope.querySelector('.sl-scroller');
        if (s) s.scrollBy({ left: (+b.dataset.slScroll) * (s.clientWidth * 0.8), behavior: 'smooth' });
      });
    });
  }

  /* Product cards: second (hover) photo is only downloaded when a mouse user hovers the card */
  document.addEventListener('mouseover', function (e) {
    var card = e.target.closest && e.target.closest('.sl-card');
    if (!card) return;
    var im = card.querySelector('img[data-sl-hover]');
    if (im && !im.getAttribute('src')) im.src = im.getAttribute('data-sl-hover');
  });

  /* Tabs */
  function initTabs(scope) {
    scope.querySelectorAll('[data-sl-tabs]').forEach(function (wrap) {
      var tabs = [].slice.call(wrap.querySelectorAll('[role=tab]'));
      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          tabs.forEach(function (o) {
            var on = o === t;
            o.setAttribute('aria-selected', on);
            var p = document.getElementById(o.getAttribute('aria-controls'));
            if (p) p.hidden = !on;
          });
        });
      });
    });
  }

  /* Opt-in: show success message after Shopify customer form posts back */
  function init(scope) {
    scope = scope || document;
    initSticky(scope); initCombo(scope); initReels(scope); initTabs(scope); initTiers();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
